export const METAFIELD_VALUES_RESOURCE_TYPES = [
  'product',
  'order',
  'order_item',
  'merchant',
  'customer',
];
